import { IconProps } from ".";

export const PowerIcon: React.FC<IconProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99992 0.666666C8.27606 0.666666 8.49992 0.890524 8.49992 1.16667V3.83333C8.49992 4.10948 8.27606 4.33333 7.99992 4.33333C7.72378 4.33333 7.49992 4.10948 7.49992 3.83333V1.16667C7.49992 0.890524 7.72378 0.666666 7.99992 0.666666ZM5.43657 2.36741C5.5711 2.60856 5.48467 2.91311 5.24352 3.04765C3.50631 4.0168 2.33325 5.87176 2.33325 8.00002C2.33325 11.1296 4.87031 13.6667 7.99992 13.6667C11.1295 13.6667 13.6666 11.1296 13.6666 8.00002C13.6666 5.88635 12.5096 4.04228 10.792 3.0677C10.5518 2.93143 10.4676 2.62626 10.6038 2.38608C10.7401 2.14591 11.0453 2.06168 11.2855 2.19795C13.3034 3.3429 14.6666 5.51195 14.6666 8.00002C14.6666 11.6819 11.6818 14.6667 7.99992 14.6667C4.31802 14.6667 1.33325 11.6819 1.33325 8.00002C1.33325 5.49475 2.71537 3.31296 4.75632 2.17435C4.99748 2.03982 5.30203 2.12625 5.43657 2.36741Z"
        fill="currentColor"
        style={{
          fill: "currentColor",
          fillOpacity: 1
        }}
      />
    </svg>
  );
};
